import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
import { Button } from '../ui/Button';
export function PShotHero() {
  return <section className="relative pt-[120px] pb-[60px] lg:pt-[160px] lg:pb-[100px] overflow-hidden min-h-[500px] lg:min-h-[70vh] flex items-center" data-id="element-1704">
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/8X3F9dJ4yi8GgGYmXi8qub/P-shot.jpg)'
    }} data-id="element-1705" />
      <div className="absolute inset-0 bg-black/50" data-id="element-1706" />

      <div className="max-w-[1200px] mx-auto px-6 lg:px-8 w-full relative z-10" data-id="element-1707">
        <AnimateOnScroll className="w-full lg:w-[55%]" data-id="element-1708">
          <div className="mb-6" data-id="element-1709">
            <span className="text-[#999999] text-[13px] font-body" data-id="element-1710">
              <a href="/treatments" className="hover:text-[#FF1493] transition-colors" data-id="element-1711">
                Treatments
              </a>{' '}
              / Medical
            </span>
          </div>

          <span className="text-[#FF1493] uppercase text-sm font-bold tracking-[3px] mb-4 block font-[Poppins,_sans-serif]" data-id="element-1712">
            Be FIERCE
          </span>

          <h1 className="text-[32px] sm:text-4xl lg:text-[52px] uppercase text-white tracking-tight mb-6 font-[600] font-[Poppins,_sans-serif] leading-none" data-id="element-1713">
            PERFORMANCE ENHANCEMENT SHOT
          </h1>

          <div className="space-y-6" data-id="element-1714">
            <p className="text-[#D0D0D0] text-base leading-[1.7] font-body" data-id="element-1715">
              <em data-id="element-1716">
                "Gentlemen, let's be honest—your partner deserves the ride of
                their life, and so do you,"
              </em>{' '}
              says Dr. Fiona Frie.{' '}
              <em data-id="element-1717">
                "If things aren't sizzling in the bedroom, why let it fizzle
                out? One simple procedure like the performance enhancement shot
                can change everything—no pills, no excuses, just results."
              </em>
            </p>
            <p className="text-[#D0D0D0] text-base leading-[1.7] font-body" data-id="element-1718">
              At Be CLINICAL, our performance enhancement shot is here to help
              men bring back the fire and make sure every performance is
              standing ovation-worthy.
            </p>
          </div>

          <Button variant="primary" size="lg" className="mt-8 w-full sm:w-auto" data-id="element-1719">
            SCHEDULE CONSULTATION
          </Button>
        </AnimateOnScroll>
      </div>
    </section>;
}